module.exports = __webpack_public_path__ + "static/logo-a92fb3dc601f6b119a6883ffcaf15023.png";